import * as mintedV2NftsApi from "api/mintedV2NftsApi";
import useFetchPromise from "hooks/useFetchPromise";

const useFetchAllV2Ids = () =>
  useFetchPromise<number[]>(mintedV2NftsApi.fetchMintedV2Ids);

export default useFetchAllV2Ids;
